module.exports = __webpack_public_path__ + "img/1PH2sk9KKpJNYT-baEFlpw.2ee6568a.svg";